import React, { useState, useEffect } from 'react';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { ModuleTitle } from '../utilities/ModuleTitle.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faPlus, faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AddClutchModal } from './modals/AddClutchModal.tsx';
import { HatchedClutchModal } from './modals/HatchedClutchModal.tsx';
import { Dropdown, TabContainer, TabPane, Table } from 'react-bootstrap';
import { ClutchReptileModal } from './modals/ClutchReptilesModal.tsx';
import { Clutch } from './types/Clutch.ts';
import { DeleteClutchModal } from './modals/DeleteClutchModal.tsx';
import { ViewClutchModal } from './modals/ViewClutchModal.tsx';
import { SubscriptionModal } from '../stripe/SubscriptionModal.tsx';
import { driver } from 'driver.js';
import { Morph } from '../../types/Morph.ts';
import { Gene } from '../../types/Gene.ts';
import { UserInfo } from '../../types/UserInfo.ts';
import { useRepToolContext } from '../../RepToolContext.tsx';

interface TabType {
  label: string,
}

const tabs = [
  { label: "Due" },
  { label: "Hatched" }
]
const Tab = ({
  tab,
  active,
  setTab
}: {
  tab: TabType,
  active: boolean,
  setTab: () => void
}) => (
  <li className="nav-item" onClick={setTab}>
    <a className={`nav-link ${active ? 'active' : ''}`} href="#">{tab.label}</a>
  </li>

)

export const ClutchDropdownMenu = ({
  setOpenAddModal,
  setOpenHatchedModal,
  setOpenClutchReptilesModal,
  setOpenDeleteModal,
  setOpenViewModal
}: {
  setOpenAddModal: (value: boolean) => void,
  setOpenHatchedModal: (value: boolean) => void,
  setOpenClutchReptilesModal: (value: boolean) => void,
  setOpenDeleteModal: (value: boolean) => void,
  setOpenViewModal: (value: boolean) => void,
}) => {
  return (
    <Dropdown.Menu className='bg-dark'>
      <Dropdown.Header className='text-blue'>Actions</Dropdown.Header>
      <Dropdown.Item className='text-light' onClick={() => setOpenAddModal(true)}>Edit</Dropdown.Item>
      <Dropdown.Item className='text-light' onClick={() => setOpenHatchedModal(true)}>Create Hatched Reptiles</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Header className='text-blue'>View</Dropdown.Header>
      <Dropdown.Item className='text-light' onClick={() => setOpenViewModal(true)}>Family Tree</Dropdown.Item>
      <Dropdown.Item className='text-light' onClick={() => setOpenClutchReptilesModal(true)}>Hatched Reptiles</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item className='text-light' onClick={() => setOpenDeleteModal(true)}>Delete</Dropdown.Item>
    </Dropdown.Menu>
  )
}

export const ClutchItem = ({ clutch, refetch, resetControls, hideActions = false, morphs, genes }: { clutch: Clutch, refetch: () => void, resetControls?: () => void, hideActions?: boolean, morphs: Morph[], genes: Gene[] }) => {
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openHatchedModal, setOpenHatchedModal] = useState<boolean>(false);
  const [openClutchReptilesModal, setOpenClutchReptilesModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);

  useEffect(() => {
    if (!openAddModal && !openHatchedModal && !openClutchReptilesModal && !openDeleteModal) {
      // if all modals have been closed refetch just to be safe
      refetch();
    }
    resetControls?.();
  }, [openAddModal, openHatchedModal, openClutchReptilesModal, openDeleteModal, openViewModal]);



  return (
    <>
      {openAddModal && <AddClutchModal closeModal={() => setOpenAddModal(false)} editingClutch={clutch} onSave={refetch} />}
      {openHatchedModal && <HatchedClutchModal closeModal={() => setOpenHatchedModal(false)} editingClutch={clutch} onSave={refetch} morphs={morphs} genes={genes} />}
      {openClutchReptilesModal && <ClutchReptileModal closeModal={() => setOpenClutchReptilesModal(false)} editingClutch={clutch} morphs={morphs} />}
      {openDeleteModal && <DeleteClutchModal closeModal={() => setOpenDeleteModal(false)} editingClutch={clutch} onDelete={refetch} />}
      {openViewModal && <ViewClutchModal clutch={clutch} onClose={() => setOpenViewModal(false)} />}

      <div className='col-md-6 clutch-item'>
        <div className={`border glow p-4 rounded mb-4  bg-black`}>
          <div className='d-flex flex-row justify-content-between'>
            <div className='d-flex flex-column justify-content-between'>
              <div className='d-flex flex-row text-center'>
                <div className='d-flex flex-column'>
                  <img src={clutch.father.picture || 'images/notavailable.jpg'} className='mx-auto rounded' width={100} />
                  <span>{clutch.father.morph_name}</span>
                </div>
                <div className='d-flex'>
                  <FontAwesomeIcon icon={faTimes} className='my-auto mx-3' size='2x' />
                </div>
                <div className='d-flex flex-column'>
                  <img src={clutch.mother.picture || 'images/notavailable.jpg'} className='mx-auto rounded' width={100} />
                  <span>{clutch.mother.morph_name}</span>
                </div>
              </div>
              <div className='mt-3'>
                <small className='text-light'>Laid on:</small>
                <h6>{new Date(clutch.laid_date).toDateString()}</h6>
              </div>
              <div className='d-lg-none'>
                <Table variant='none' className='mb-0' size='sm' style={{ background: 'none' }}>
                  <thead>
                    <tr>
                      <th className='py-0' colSpan={4}>
                        <small className='text-light'>Eggs:</small>
                      </th>
                    </tr>
                    <tr>
                      <th className='text-start pt-0'>Total</th>
                      <th className='text-center pt-0'>Slugs</th>
                      <th className='text-center pt-0'>Remaining</th>
                      <th className='pt-0'></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className='text-center'>{clutch.number_of_eggs}</td>
                      <td className='text-center'>{clutch.number_of_slugs}</td>
                      <td className='text-center'>{clutch.remaining_eggs}</td>
                      <td>
                        <Dropdown className='mt-auto'>
                          <Dropdown.Toggle variant="dark" size='sm'>
                            <FontAwesomeIcon icon={faPen} className='mr-2' />
                          </Dropdown.Toggle>
                          <ClutchDropdownMenu
                            setOpenAddModal={setOpenAddModal}
                            setOpenHatchedModal={setOpenHatchedModal}
                            setOpenClutchReptilesModal={setOpenClutchReptilesModal}
                            setOpenDeleteModal={setOpenDeleteModal}
                            setOpenViewModal={setOpenViewModal}
                          />
                        </Dropdown>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>

            </div>

            <div className='ml-3 flex-column d-none d-lg-flex'>
              <h6>Total: {clutch.number_of_eggs}</h6>
              <h6>Slugs: {clutch.number_of_slugs}</h6>
              <h6>Remaining: {clutch.remaining_eggs}</h6>
              {!hideActions && <Dropdown className='mt-auto'>
                <Dropdown.Toggle variant="dark" >
                  <FontAwesomeIcon icon={faPen} className='mr-2' />
                </Dropdown.Toggle>

                <ClutchDropdownMenu
                  setOpenAddModal={setOpenAddModal}
                  setOpenHatchedModal={setOpenHatchedModal}
                  setOpenClutchReptilesModal={setOpenClutchReptilesModal}
                  setOpenDeleteModal={setOpenDeleteModal}
                  setOpenViewModal={setOpenViewModal}
                />
              </Dropdown>}
            </div>
          </div>
        </div>
      </div>

    </>

  )
}
const FloatButtons = ({ toggleOpenAddModal, toggleTutorial }: {
  toggleOpenAddModal: () => void,
  toggleTutorial: () => void

}) => {
  return (
    <div className="d-flex flex-row ml-auto justify-content-end mb-2">
      <span className="mr-4" onClick={toggleTutorial} >
        <FontAwesomeIcon size='xl' icon={faQuestion} />
      </span>
      <span id='add-clutch-button' onClick={toggleOpenAddModal} className="mr-2">
        <FontAwesomeIcon size='xl' icon={faPlus} />
      </span>
    </div>
  )
}

export const Clutches = ({ backToMenu, morphs, genes, userInfo }: { backToMenu: () => void, morphs: Morph[], genes: Gene[], userInfo: UserInfo }) => {
  const [clutches, setClutches] = useState<Clutch[]>([]);
  const [fetchingData, setFetchingData] = useState<boolean>(true);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState<boolean>(false);
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const { appendControls } = useRepToolContext();
  const driverObj = driver({
    steps: [
      { popover: { description: 'This is the clutches feature, here you can record clutches you have produced. This is a helpful tool that allows you to not only improve your record keeping but will also give you insight into what females are producing the most viable eggs.' } },
      { element: '#add-clutch-button', popover: { title: 'Create Clutch', description: 'This is the button that will allow you to add a new clutch. You can then specify the parents and number of viable eggs.' } },
      { element: '#clutches', popover: { title: 'Clutches', description: 'These are your clutches. Here you can see the parents of each clutch and the number of eggs laid. You can add new reptiles to your collection using the create hatched option or edit a clutch at any time.' } },
    ]
  });


  const fetchClutches = () => {
    let url = `${(window as any).serverLocation}clutch/get_all`;
    BasicFetch({
      url,
      extra: {
        reptile: localStorage.getItem('selectedReptile')
      },
      onSuccess: (clutches) => {
        setClutches(clutches);
      },
      onFail: () => {
      },
      onFinish: () => {
        setFetchingData(false);
      }
    })
  }
  const resetControls = () => {
    appendControls(<FloatButtons toggleOpenAddModal={() => {
      if (userInfo.subscription?.subscription_type === 'FREE') {
        setOpenSubscriptionModal(true);
      } else {
        setOpenAddModal(true);
      }
    }} toggleTutorial={() => driverObj.drive()} />, "Clutches");
  }
  useEffect(() => {
    fetchClutches();
    resetControls();
  }, [openAddModal, openSubscriptionModal]);


  useEffect(() => {
    if (fetchingData) {
      fetchClutches();
    }
  }, [fetchingData]);
  const refetch = () => setFetchingData(true);


  const filteredClutches: {
    Due: Clutch[],
    Past: Clutch[]
  } = { "Due": [], "Past": [] }
  clutches.forEach(clutch => {
    if (clutch.remaining_eggs > 0) {
      filteredClutches.Due.push(clutch)
    } else {
      filteredClutches.Past.push(clutch);
    }
  })


  return <div className='fadeIn animated' style={{ paddingBottom: 85 }}>
    {openAddModal && <AddClutchModal closeModal={() => setOpenAddModal(false)} editingClutch={null} onSave={refetch} genes={genes} morphs={morphs} />}
    {openSubscriptionModal && <SubscriptionModal displayFeatureRequiresMessage={true} userInfo={userInfo} closeModal={() => setOpenSubscriptionModal(false)} />}
    <ModuleTitle title="Clutches" backToMenu={() => backToMenu()} />
    <TabContainer activeKey={activeIndex} onSelect={(index) => setActiveIndex(parseInt(index || '0'))}>
      <ul id='nav-tabs' className="nav nav-tabs">
        {tabs.map((tab, index) => (
          <Tab key={tab.label} setTab={() => { setActiveIndex(index); localStorage.setItem("selectedTab", index.toString() || '0') }} active={index === activeIndex} tab={tab} />
        ))}
      </ul>
      <div id='clutches'>
        <TabPane eventKey={0} className='d-flex flex-row mt-3 flex-wrap'>
          {filteredClutches.Due.map((clutch) => (
            <ClutchItem clutch={clutch} key={clutch.id} refetch={refetch} resetControls={resetControls} morphs={morphs} genes={genes} />
          ))}
        </TabPane>
        <TabPane eventKey={1} className='d-flex flex-row mt-3 flex-wrap'>
          {filteredClutches.Past.map((clutch) => (
            <ClutchItem clutch={clutch} key={clutch.id} refetch={refetch} resetControls={resetControls} morphs={morphs} genes={genes} />
          ))}
        </TabPane>
      </div>
    </TabContainer>
  </div>
}